import { Group } from '@/components/_common';
import { useUserValidateCode } from '@/core/domain/enterprise/Users/Users.hooks';
import { useRouteMatchParam } from '@/hooks';
import { Button, Card, Space, Spin, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import Logo from '@/assets/images/Logo_Footer.png';
import { useHistory } from 'react-router-dom';

import './style.less';

const AccountValidatePage: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>(
    'loading',
  );
  const [result, setResult] = useState({
    title: 'Validando o código',
    message: 'Verificando e válidando o código de ativação',
  });
  const history = useHistory();

  const isLoading = status === 'loading';
  const isSuccess = status === 'success';
  const isError = status === 'error';

  const code = useRouteMatchParam('code');

  const validateCode = useUserValidateCode();

  useEffect(() => {
    if (code) {
      (async () => {
        await validateCode
          .mutateAsync(code)
          .then(() => {
            setStatus('success');
            setResult({
              title: 'Ativado!',
              message: 'Conta ativada com sucesso!',
            });
          })
          .catch(() => {
            setStatus('error');
            setResult({
              title: 'Não ativado!',
              message:
                'O código não é mais válido, ou não foi possível ativar a conta, solicite um novo código de ativação!',
            });
          });
      })();
    }
  }, [code]);

  return (
    <Group
      position="center"
      align="center"
      gap={24}
      className="accountValidate"
    >
      <img src={Logo} height={40} style={{ marginBottom: 24 }} />

      <Card
        style={{ maxWidth: 600, width: 600 }}
        bodyStyle={{ padding: 0 }}
        className="accountValidate-card"
      >
        <Space
          direction="vertical"
          align="center"
          className={`accountValidate-card-header -${status}`}
        >
          {isLoading && <Spin />}
          {isSuccess && <AiOutlineCheckCircle size={50} color="white" />}
          {isError && <AiOutlineCloseCircle size={50} color="white" />}

          <Typography.Title level={4}>{result.title}</Typography.Title>
        </Space>

        <div className="accountValidate-card-body">
          <p>{result.message}</p>
          <Group position="center">
            {isError && (
              <Button type="primary" onClick={() => history.push('/')}>
                Voltar ao início
              </Button>
            )}

            {isSuccess && (
              <Button type="primary" onClick={() => history.push('/login')}>
                Acessar conta
              </Button>
            )}
          </Group>
        </div>
      </Card>
    </Group>
  );
};

export default AccountValidatePage;
